export default __webpack_public_path__ + "static/media/map-pushpin.7963348f.svg";